
import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import App from './App.tsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'

// Find the root element
const rootElement = document.getElementById("root");

// Handle case where root element might be missing
if (!rootElement) {
  console.error("Root element not found, creating a fresh one");
  const newRoot = document.createElement('div');
  newRoot.id = 'root';
  document.body.appendChild(newRoot);
  
  // Create and render our application
  const root = createRoot(newRoot);
  root.render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );
} else {
  // Normal flow - create and render our application
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );
}
